import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SubmissionSourceModalRequest } from './modal-request';


@Injectable()
export class ModalService {

    private submissionSourceSubject = new Subject<SubmissionSourceModalRequest>();
    public submissionSourceModalRequests$ = this.submissionSourceSubject.asObservable();


    // Called by components when a submission source modal is desired.
    // Should trigger a submission source dialog to appear.
     public openSubmissionSourceDialog(uuid: string, hmlId: string, uploaderFileName: string, submissionStatus: string, testType?: string) {
         this.submissionSourceSubject.next(new SubmissionSourceModalRequest(uuid, hmlId, uploaderFileName, submissionStatus, testType));
     }
}
